module.exports = __webpack_public_path__ + "img/ico_fcu_4.935c6996.png";